import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { Link, useHistory } from 'react-router-dom';
import useDocs from '../../hooks/useDocs';
import '../../styles/Dashboard.css';

export default function Dashboard() {
  const [error, setError] = useState('');
  const { currentUser, logout } = useAuth();
  const history = useHistory();
  const { docs, loading } = useDocs('profiles');

  async function handleLogout() {
    setError('');
    try {
      await logout();
      history.push('/login');
    } catch {
      setError('Failed to log out');
    }
  }

  return (
    <div className="dashboard-page">
      <h1 className="dashboard-title">Account</h1>

      <div className="dashboard-card">
        {error && <Alert variant="danger">{error}</Alert>}

        <p className="dashboard-email">
          <strong>Email:</strong>
          {currentUser?.email}
        </p>

        <Link
          to={docs.username ? `/user/${docs.username}` : '/user-redirect'}
          className="dashboard-btn"
        >
          {loading ? 'Loading profile...' : 'Your profile page'}
        </Link>

        <Link to="/update-profile" className="dashboard-btn">
          Update Profile
        </Link>

        <Link to="/home" className="dashboard-btn dashboard-btn--outline">
          Feed
        </Link>

        <button type="button" className="dashboard-logout" onClick={handleLogout}>
          Log out
        </button>
      </div>
    </div>
  );
}
